import { useState } from 'react';

export type SearchFilterType =
  | 'medicalSubject'
  | 'medicalCare'
  | 'appealPoint'
  | 'loginRequire';

export const usePopover = () => {
  const [searchFilterEl, setSearchFilterEl] =
    useState<HTMLButtonElement | null>(null);
  const [searchFilterType, setSearchFilterType] =
    useState<SearchFilterType | null>(null);

  const openSearchFilter = (
    event: React.MouseEvent<HTMLButtonElement>,
    searchFilterType: SearchFilterType,
  ) => {
    setSearchFilterEl(event.currentTarget);
    setSearchFilterType(searchFilterType);
  };

  const closeSearchFilter = () => {
    setSearchFilterEl(null);
    setSearchFilterType(null);
  };

  return {
    searchFilterEl,
    searchFilterType,
    openSearchFilter,
    closeSearchFilter,
  };
};
